
export const PageDataState = {    
    Searchs: {
        region_id: {
            type: 'select',
            id: 'region_id',
            label: 'ภูมิภาค',
            value: '',
            placeholder: 'ภูมิภาค',
        },
        province_name: {
            type: 'text',
            id: 'province_name',
            label: 'จังหวัด',
            value: '',
            placeholder: 'จังหวัด',
        },
    },
    Inputs: {
        region_id: {
            type: 'select',
            id: 'region_id',
            label: 'ภูมิภาค',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: true,
                minLength: 2,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'จังหวัด',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}